module.exports = __webpack_public_path__ + "img/tres_guerras.070aa875.svg";